import { render, staticRenderFns } from "./ChartjsHorizontalBarChartProgress.vue?vue&type=template&id=184bfcba&"
import script from "./ChartjsHorizontalBarChartProgress.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartProgress.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports